var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"px-0",attrs:{"xs":"12","sm":"12","md":"12","lg":"12","xl":"4"}},[_c('b-form-group',{staticClass:"mb-0",attrs:{"label-size":"sm"}},[(_vm.typeCarrier == 'supplier')?_c('vue-single-select',{attrs:{"classes":{
        input: 'form-control',
        dropdown: 'dropdown',
        wrapper: 'single-select-wrapper-tight',
      },"options":_vm.suppliers,"optionLabel":"companyName"},model:{value:(_vm.form.supplier),callback:function ($$v) {_vm.$set(_vm.form, "supplier", $$v)},expression:"form.supplier"}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }